export type VehiclePhotoResponse = {
  id: string;
  fileId: string;
  albumId: string;
  weight: number;
  isCoverPhoto: boolean;
  remoteFileId: string;
  /**
   * This is the real field which was returned to API instead of isCoverPhoto, leave it for FE BC
   */
  coverPhoto?: boolean;
  url: string;
};
